import React from 'react'
import styled from 'styled-components'

function Header(props){
  return (
    <HeaderStyle>{props.children}</HeaderStyle>
  )
}

export default Header

const HeaderStyle = styled.div`
	display: flex;
	width: 100%;
	position: relative;
	align-items: center;
	font-weight: 500;
	font-size: 20px;
	border-bottom: 1px solid #EFEFEF;
	padding-left: 25px;
	h1,h2,h3,h4,h5,h6,p,a,ol,li{
	    color: white;
	    margin: 0;
	}
`


// WEBPACK FOOTER //
// ./components/header/header.js